
const OrderRoutes = [
  { path: '/order', component: () => import('@/views/OrderAdmin/Order/index.vue') },
  { path: '/orderHs', component: () => import('@/views/OrderAdmin/Order/index.vue') },
  { path: '/orderYxj', component: () => import('@/views/OrderAdmin/Order/index.vue') },
  { path: '/TKOrder', component: () => import('@/views/OrderAdmin/TKOrder/index.vue') },
  { path: '/TKOrderYxj', component: () => import('@/views/OrderAdmin/TKOrder/index.vue') },
  { path: '/TKOrder/taobao', component: () => import('@/views/OrderAdmin/TKOrder/index.vue') },
  { path: '/TKOrder/douYin', component: () => import('@/views/OrderAdmin/TKOrder/index.vue') },
  { path: '/balancepayment', component: () => import('@/views/OrderAdmin/BalancePayment/index.vue') },
  { path: '/auxiliaryQuery', component: () => import('@/views/OrderAdmin/auxiliaryQuery/index.vue') },
  { path: '/refund', component: () => import('@/views/OrderAdmin/Refund/index.vue') },
  { path: '/refund/express-fee', component: () => import('@/views/OrderAdmin/Refund/components/ExpressFee/index.vue') },
  { path: '/refund/rebate', component: () => import('@/views/OrderAdmin/Refund/components/Rebate/index.vue') },
  { path: '/orderDetail', component: () => import('@/views/OrderAdmin/orderDetails/index.vue') },
  { path: '/saledSelect', component: () => import('@/views/OrderAdmin/SaledSelect/index.vue') },
  { path: '/saledQuestionType', component: () => import('@/views/OrderAdmin/SaledQuestionType/index.vue') },
  { path: '/balanceapply', component: () => import('@/views/OrderAdmin/BalanceApply/index.vue') },
  { path: '/task', component: () => import('@/views/OrderAdmin/Task/index.vue') },
  { path: '/taskHs', component: () => import('@/views/OrderAdmin/Task/index.vue') },
  { path: '/taskYxj', component: () => import('@/views/OrderAdmin/Task/index.vue') },
  { path: '/TKOrderSettlement', component: () => import('@/views/OrderAdmin/TKOrder/settlement/index.vue') },
  { path: '/TKOrderSettlementDetail', component: () => import('@/views/OrderAdmin/TKOrder/settlement/detail.vue') },
  { path: '/sample', component: () => import('@/views/OrderAdmin/sample/index.vue') },
  { path: '/pointsDetails', component: () => import('@/views/OrderAdmin/pointsDetails/index.vue') },
  { path: '/changePoints', component: () => import('@/views/OrderAdmin/pointsDetails/changePoint.vue') },
  { path: '/cart', component: () => import('@/views/ShoppingTrolley/index.vue') }
]

export default OrderRoutes
